<template>
<!-- <v-container fluid> -->
  <v-layout row>
    <v-flex xs3 >
        <v-select
          @focus="focus = true"        
          @blur="focus = false"    
          style="padding-left:5px;"
          dense
          :items="countries"
          v-model="country"
          >
            <template slot="item" slot-scope="data">
                <country-flag style="border-radius:3px;" :country="data.item"></country-flag>
                <span style="padding-left:10px;">{{data.item}}</span>
            </template>

            <template slot="prepend">
          <country-flag class="d-flag" :country="country"></country-flag>

            </template>
          </v-select>
        <!-- </v-layout> -->
    </v-flex>

    <v-flex xs9 >
      <v-text-field
        :label="label"
        @focus="focus = true"        
        @blur="focus = false"
        v-model="phone"
        :error="error"
        :error-messages="message"
        v-on:blur='handleBlur'
      >
      </v-text-field>
    </v-flex>
  </v-layout>
<!-- </v-container> -->
</template>

<script>
import { ParseError, parsePhoneNumber } from "libphonenumber-js";
import CountryFlag from "vue-country-flag";

export default {
  props: ["value", "label"],
  components: {
    CountryFlag
  },
  data() {
    return {
      phone: "",
      error: false,
      message: "",
      focus: false,
      countries: [
        "NL",
        "BE",
        "FR",
        "GB",
        "DE",
        "US",
        "LU",
        "DK",
        "NO",
        "FI",
        "SE",
        "ES"
      ],
      country: "NL"
    };
  },
  methods: {
    handleBlur() {
      if (this.phone !== undefined && this.phone != "") {
        try {
          const checkNumber = parsePhoneNumber(this.phone, this.country);
          if (checkNumber.country !== this.country) {
            this.error = true;
            this.message =
              "Telefoonummer voldoet niet aan de eisen van het land.";
            return;
          }
          if (!checkNumber.isValid()) {
            this.error = true;
            this.message = "Telefoonnummer is niet geldig";
          } else {
            this.error = false;
            this.message = "";
          }
        } catch (error) {
          if (error instanceof ParseError) {
            this.error = true;
            this.message = "Telefoonnummer is niet geldig";
          } else {
            throw error;
          }
        }
      } else {
        this.error = false;
        this.message = "";
      }
    }
  },
  watch: {
    country() {
      this.handleBlur();
    },
    value() {
      this.phone = this.value;
    },
    phone() {
      try {
        const phoneNumber = parsePhoneNumber(this.phone, this.country);
        this.phone = phoneNumber.number;
        this.$emit("input", this.phone);
      } catch (error) {}
    },
    error() {
      if (this.error) {
        this.$store.state.app.form.disabled = true;
      } else if (!this.error) {
        this.$store.state.app.form.disabled = false;
      }
    }
  },
  created() {
    this.phone = this.value;
    try {
      const phoneNumber = parsePhoneNumber(this.phone);
      this.country = phoneNumber.country;
    } catch (error) {}
  }
};
</script>

<style scoped>
.d-flag {
  transform: scale(0.45);
}

.d-title {
  transition: color 0.3s ease-out;
  color: #757575;
  position: absolute;
}

.error-text {
  transition: color 0.3s ease-out;
  color: #d3223c !important;
}
.focus-text {
  transition: color 0.3s ease-out;
  color: #003657;
}
</style>

